<form>
  <div class="row">
    <div class="col-md-12">
      <div class="input-group">
        <span class="input-group-text"
          ><label for="length">Longitud:</label></span
        >
        <input
          class="form-control"
          type="number"
          id="length"
          name="length"
          [(ngModel)]="length"
          min="8"
          max="20"
        />
      </div>
    </div>
    <div class="col-md-12">
      <label for="uppercase">Mayúsculas:</label>
      <input
        type="checkbox"
        id="uppercase"
        name="uppercase"
        [(ngModel)]="uppercase"
      />
    </div>
    <div class="col-md-12">
      <label for="specialChars">Caracteres especiales:</label>
      <input
        type="checkbox"
        id="specialChars"
        name="specialChars"
        [(ngModel)]="specialChars"
      />
    </div>
  </div>
  <button type="button" class="btn btn-success" (click)="generatePassword()">
    Generar
  </button>
</form>
<div *ngIf="password" class="password alert alert-warning">
  <p>Tu nueva contraseña es:</p>
  <p>
    <b>{{ password }}</b>
  </p>
  <p>
    <button type="button" class="btn btn-primary" (click)="copyPassword()">
      Copíar <i class="fa-regular fa-copy"></i>
    </button>
  </p>
</div>
